<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('currencies.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openCurrencyForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetCurrencies(true)"></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"
                            >
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.is_active"
                                                color="success"
                                                :label="filter.is_active == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="currencies" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openCurrencyForm(props.item)">
                                <td>{{ props.item.code }}</td>
                                <td>{{ props.item.name }}</td>
                                <td class="text-center">{{ props.item.prefix }}</td>
                                <td class="text-center">{{ props.item.suffix }}</td>
                                <td class="text-center">{{ props.item.precision }}</td>
                                <td class="text-center">{{ props.item.decimal }}</td>
                                <td class="text-center">{{ props.item.thousands }}</td>
                                <td class="text-center">{{ props.item.mask }}</td>
                                <td class="text-center">
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.status_display }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="currencies"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="currency_dialog">
                <v-card>
                    <v-form ref="form_currency">
                        <v-card-title>
                            <span class="headline">{{ currency.currency_id ? $t("lang.edit_currency") : $t("lang.add_currency") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeCurrencyDialog"
                                :dialog-status="currency_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="currency.code"
                                            :label="`${$t('lang.code')} *`"
                                            :counter="showCounter(currency.code, 'currencies.code')"
                                            :rules="ifValid('currencies.code')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="currency.name"
                                            :label="`${$t('lang.name')} *`"
                                            :counter="showCounter(currency.name, 'currencies.name')"
                                            :rules="ifValid('currencies.name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="currency.prefix"
                                                :label="`${$t('lang.prefix')}`"
                                                :counter="showCounter(currency.prefix, 'currencies.prefix')"
                                                :rules="ifValid('currencies.prefix')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="currency.suffix"
                                                :label="`${$t('lang.suffix')}`"
                                                :counter="showCounter(currency.suffix, 'currencies.suffix')"
                                                :rules="ifValid('currencies.suffix')"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                v-model="currency.precision"
                                                :label="`${$t('lang.precision')} *`"
                                                :counter="showCounter(currency.precision, 'currencies.precision')"
                                                :rules="ifValid('currencies.precision')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                v-model="currency.decimal"
                                                :label="`${$t('lang.decimal_sep')}`"
                                                :counter="showCounter(currency.decimal, 'currencies.decimal')"
                                                :rules="ifValid('currencies.decimal')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                v-model="currency.thousands"
                                                :label="`${$t('lang.thousands_sep')}`"
                                                :counter="showCounter(currency.thousands, 'currencies.thousands')"
                                                :rules="ifValid('currencies.thousands')"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="currency.mask"
                                            :label="`${$t('lang.mask')}`"
                                            :counter="showCounter(currency.mask, 'currencies.mask')"
                                            :rules="ifValid('currencies.mask')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-switch
                                            v-model="currency.is_active"
                                            color="success"
                                            :label="currency.is_active == '1' ? $t('lang.active') : $t('lang.inactive')"
                                            true-value="1"
                                            false-value="0"
                                        ></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="currency.currency_id" color="error" @mouseup.left="$refs.delete_currencies.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeCurrencyDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveCurrencies">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_currencies"
                :heading="$t('lang.delete_currency')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteCurrencies(currency.currency_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openCurrencyForm" },
                { title: this.$t("lang.refresh"), action: "dbGetCurrencies", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.code"), sortable: false, width: "10%" },
                { text: this.$t("lang.name"), sortable: false, width: "30%" },
                { text: this.$t("lang.prefix"), sortable: false, width: "8%", align: "center" },
                { text: this.$t("lang.suffix"), sortable: false, width: "8%", align: "center" },
                { text: this.$t("lang.precision"), sortable: false, width: "8%", align: "center" },
                { text: this.$t("lang.decimal_sep"), sortable: false, width: "8%", align: "center" },
                { text: this.$t("lang.thousands_sep"), sortable: false, width: "8%", align: "center" },
                { text: this.$t("lang.mask"), sortable: false, width: "10%" },
                { text: this.$t("lang.status"), sortable: false, width: "10%", align: "center" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            currency: { is_active: "1" },
            filter: {
                search: "",
                is_active: "1",
                page_size: 20,
                page_num: 1,
            },
            currency_dialog: false,
            dbGetCurrencies: _.debounce(this.getCurrencies, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchCurrencies", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.currencies) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchCurrencies({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.currencies) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.currencies.currencies_filter,
            page: (state) => state.currencies.page,
            rules_currencies: (state) => state.currencies.rules_currencies,
            currency_status_options: (state) => state.settings.currency_status_options,
            currencies: (state) => state.currencies.currencies,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchCurrencies", "saveCurrency", "deleteCurrency"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openCurrencyForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_currency) item ? this.$refs.form_currency.resetValidation() : this.$refs.form_currency.reset();

                    this.$nextTick(() => {
                        this.currency = item != null ? this.assignObj2(item, this.rules_currencies) : {};
                        this.currency_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "currency", params: { id: item.currency_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_currency) item ? this.$refs.form_currency.resetValidation() : this.$refs.form_currency.reset();
                    this.currency_dialog = true;
                } else {
                    this.$router.push({ name: "currency" });
                }
            }
        },
        saveCurrencies() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_currency")) {
                    let body = this.prepForm(this.currency, this.rules_currencies);

                    this.saveCurrency({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getCurrencies();
                                this.closeCurrencyDialog();
                            } else {
                                this.$router.push({ name: "currency", params: { id: data.currency_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteCurrencies(id = null) {
            this.deleteCurrency({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getCurrencies();
                    this.closeCurrencyDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeCurrencyDialog() {
            this.currency_dialog = false;
            this.$refs.delete_currencies.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getCurrencies(pg_refresh = false) {
            this.startLoader();

            this.fetchCurrencies({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.currency_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
    },
};
</script>
